<script>
  import InfoHint from './InfoHint.svelte';
  import { t } from '../i18n/index.js';

  /**
   * The badge of a gated feature the account holds, with a one-line
   * explanation of what that means. Only the experimental kind gets one by
   * default: a preview is something the user should know can still change.
   * A dedicated feature shows its badge where `dedicated` is passed.
   *
   * Colours come from the shared `.badge` classes (theme tokens), never from a
   * theme id.
   */
  export let kind = 'experimental';
  /** Add the "what is this" hint next to the badge. */
  export let hint = true;
</script>

{#if kind === 'experimental' || kind === 'dedicated'}
  <span class="feature-badge inline-flex items-center gap-1 align-middle">
    <span class="badge badge-blue" data-feature-kind={kind}>{$t(`features.badge.${kind}`)}</span>
    {#if hint}<InfoHint text={$t(`features.badge.${kind}Help`)} />{/if}
  </span>
{/if}
